import { combineReducers } from 'redux';

import * as types from 'modules/campaigns/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

/**
 * @typedef {{
 *  open: boolean,
 * }} CampaignUIModalSendTestReducer
 */

export default combineReducers({
  open: createReducer(false, {
    [types.OPEN_SEND_TEST_MODAL]: () => true,
    [types.CLOSE_SEND_TEST_MODAL]: () => false,
    [types.SEND_CAMPAIGN_SUCCESS]: () => false,
  }),
});
